module.exports = __webpack_public_path__ + "static/media/amex.91be6d87.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/amex.svg
// module id = 799
// module chunks = 0